import { cn } from "~/lib/utils";

export type StockStatusTone = "success" | "warning" | "danger" | "info";

export interface StockStatus {
  label: string;
  tone: StockStatusTone;
}

export function deriveStockStatus(input: {
  stock: number;
  lowStockThreshold: number;
  isPreorder?: boolean;
  backorderable?: boolean;
}): StockStatus {
  if (input.isPreorder) return { label: "Pre-order", tone: "info" };
  if (input.stock <= 0 && input.backorderable) {
    return { label: "Available to backorder", tone: "info" };
  }
  if (input.stock <= 0) return { label: "Out of stock", tone: "danger" };
  if (input.stock <= input.lowStockThreshold) {
    return { label: `Only ${input.stock} left`, tone: "warning" };
  }
  return { label: "In stock", tone: "success" };
}

const TONE_CLASSES: Record<StockStatusTone, string> = {
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
  info: "text-info",
};

export function StockLabel({ status }: { status: StockStatus }) {
  return (
    <p
      aria-live="polite"
      aria-atomic="true"
      data-testid="pdp-stock"
      className={cn("text-sm font-medium", TONE_CLASSES[status.tone])}
    >
      {status.label}
    </p>
  );
}
